import React from 'react';
import { useTranslation } from 'react-i18next';
import AntdCustomButton from './AntdCustomButton';
import { BodyText, SmallText } from '../ui/Typography';

interface Props {
  onBuy?: () => void;
  className?: string;
}

const PreviewCTA: React.FC<Props> = ({ onBuy, className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`preview-cta-wrapper pulse fixed z-[1000] opacity-100
        max-md:left-3 max-md:right-3 max-md:translate-x-0 max-sm:bottom-[62px] max-md:bottom-[72px] max-md:max-w-none max-md:w-auto
        md:left-[50%] md:translate-x-[-50%] md:w-[calc(100%-88px)] md:bottom-[118px] md:max-w-[calc(100%-88px)]
        w-full rounded-[11px] md:rounded-full mx-auto`}>
      <span className="pulse-border pointer-events-none" />
      <div
        className={`relative z-50 flex items-center justify-between gap-2 rounded-[11px] md:rounded-full
          px-3 py-3 md:px-[38px] md:py-[22px] ${className || ''}`}
        style={{
          background: 'rgba(52,152,219,1)'
        }}>
        <div className="flex flex-col gap-1 md:gap-[8px] text-white relative z-10 min-w-0 flex-1">
          <BodyText
            className="text-white font-semibold text-sm md:text-2xl max-md:text-lg"
            style={{ lineHeight: '1.2', marginBottom: '0', fontSize: '18px' }}>
            {t('Ready to go live?')}
          </BodyText>

          <BodyText
            className="text-white text-xs md:text-base"
            style={{ lineHeight: '1.3', marginBottom: '0', fontSize: '12px' }}>
            {t('Publish now and get a ')}
            <strong className="block md:inline" style={{ fontWeight: 700 }}>
              {t('30 days free trial!')}
            </strong>
          </BodyText>
        </div>

        <div className="flex flex-col items-center gap-0.5 md:gap-1 relative z-10 shrink-0">
          <AntdCustomButton onClick={() => onBuy?.()} appearance="default">
            <>
              <span className="md:hidden font-bold max-md:text-sm max-md:px-1">
              {t('Publish')}
              </span>
              <span className="hidden md:inline">{t('Publish website now!')}</span>
            </>
          </AntdCustomButton>
          <SmallText
            className="max-md:text-[10px] max-md:leading-tight"
            style={{ marginBottom: '0', lineHeight: '20px' }}>
            {t('Checkout with')} <strong>stripe</strong>
          </SmallText>
        </div>
      </div>
    </div>
  );
};

export default PreviewCTA;
